"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trekkerFactory = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const react_1 = (0, tslib_1.__importStar)(require("react"));
const es6_1 = (0, tslib_1.__importDefault)(require("fast-deep-equal/es6"));
const bus_1 = require("./bus");
const trekker_1 = require("./trekker");
function useMemoCompare(next, compare) {
    // Ref for storing previous value
    const previousRef = (0, react_1.useRef)();
    const previous = previousRef.current;
    // Pass previous and next value to compare function
    // to determine whether to consider them equal.
    const isEqual = compare(previous, next);
    // If not equal update previousRef to next value.
    // We only update if not equal so that this hook continues to return
    // the same old value if compare keeps returning true.
    (0, react_1.useEffect)(() => {
        if (!isEqual) {
            previousRef.current = next;
        }
    });
    // Finally, if equal then return the previous value
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isEqual ? previous : next;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function trekkerFactory(init) {
    const bus = new bus_1.TrekkerEventBus();
    const TrekkerContext = (0, react_1.createContext)(null);
    function TrekkerProvider({ children, context }) {
        const initContext = init ? Object.assign({}, init()) : {};
        const fullContext = Object.assign(Object.assign({}, initContext), (context || {}));
        const newTrekker = useMemoCompare(new trekker_1.Trekker(fullContext, bus), (prev, next) => (0, es6_1.default)(prev === null || prev === void 0 ? void 0 : prev.context, next.context));
        return (react_1.default.createElement(TrekkerContext.Provider, { value: newTrekker }, children));
    }
    const TrekkerContextPasser = ({ trekker, context, children }) => {
        const newTrekker = useMemoCompare(trekker.addToContext(context), (prev, next) => (0, es6_1.default)(prev === null || prev === void 0 ? void 0 : prev.context, next.context));
        return react_1.default.createElement(TrekkerContext.Provider, { value: newTrekker }, children);
    };
    function WithTrekkerContext({ children, context }) {
        return (react_1.default.createElement(TrekkerContext.Consumer, null, (trekker) => (react_1.default.createElement(TrekkerContextPasser, { trekker: trekker, context: context }, children))));
    }
    function useTrekker() {
        const trekker = (0, react_1.useContext)(TrekkerContext);
        return trekker;
    }
    function useOnTrekkerMount(callback) {
        const trekker = (0, react_1.useContext)(TrekkerContext);
        const [isMounted, setMounted] = (0, react_1.useState)(false);
        (0, react_1.useEffect)(() => {
            if (trekker && !isMounted) {
                setMounted(true);
                callback(trekker);
            }
        }, [trekker, isMounted]);
    }
    const TC = WithTrekkerContext;
    const Trek = WithTrekkerContext;
    function TrekkerHoc(context) {
        return function (ComposedComponent) {
            return (props) => (react_1.default.createElement(Trek, { context: context },
                react_1.default.createElement(ComposedComponent, Object.assign({}, props))));
        };
    }
    const WithTrekker = TrekkerContext.Consumer;
    return {
        useOnTrekkerMount,
        WithTrekker,
        TrekkerProvider,
        TC, Trek, TrekkerHoc,
        useTrekker, WithTrekkerContext, bus
    };
}
exports.trekkerFactory = trekkerFactory;
//# sourceMappingURL=factory.js.map